import cx from "classnames";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import PKHBtn from "~/components/common/atoms/Button";
import Drawer from "~/components/mobile/atoms/Drawer";
import { changeDirection } from "~/store/totalData/actions";
import { urlLogoHeaderWhite } from "~/utils/manageResource";
import AppId from "~/utils/partner";
import styles from "./style.module.scss";

class NavBar extends React.Component {
  static defaultProps = {
    leftContent: "Back",
    children: (
      <Link to="/" className={styles.logo}>
        <img
          src={urlLogoHeaderWhite}
          alt=""
          className={
            AppId === "medpro" ? styles.img_medpro : styles.img_hospital
          }
        />
      </Link>
    ),
    mode: "blue",
    hideLeft: false
  };

  state = {
    isDrawer: false
  };

  render() {
    const {
      children,
      onLeftClick,
      rightContent,
      onRightClick,
      hideLeft,
      className,
      onClickSearch
    } = this.props;
    const { isDrawer } = this.state;
    this.onLeftButtonClick = onLeftClick || this.onLeftButtonClick;
    let toggleMenuDrawer;
    if (
      rightContent &&
      rightContent[0] &&
      rightContent[0].props.children === "Menu"
    )
      toggleMenuDrawer = this.handleToggle;

    return (
      <Fragment>
        <div
          className={cx(
            styles.header,
            styles[className],
            styles["header_" + AppId],
            "d-block d-lg-none"
          )}
        >
          {!hideLeft ? (
            <PKHBtn
              back_navbar="back_navbar"
              column="column"
              color=""
              icon={<i className="fal fa-long-arrow-left" />}
              onClick={() => this.onLeftButtonClick()}
            >
              Back
            </PKHBtn>
          ) : (
            []
          )}
          <div className={styles.header__center}>{children}</div>
          {rightContent ? (
            <div
              className={styles.header__right}
              onClick={
                toggleMenuDrawer || onClickSearch || onRightClick || (() => {})
              }
            >
              {rightContent}
            </div>
          ) : (
            []
          )}
        </div>
        <Drawer isDrawer={isDrawer} handleToggle={() => this.handleToggle()} />
      </Fragment>
    );
  }

  handleToggle = () => {
    this.setState({ isDrawer: !this.state.isDrawer });
  };

  onLeftButtonClick = () => {
    if (!this.props.redirectToHome) {
      this.props.changeDirection();
      this.props.history.goBack();
      if (!this.props.history.location.key) this.props.history.replace("/");
    } else this.props.history.push("/");
  };
}

const mapStateToProps = state => {
  const { partner } = state;
  return {
    partner
  };
};

export default connect(mapStateToProps, { changeDirection })(
  withRouter(NavBar)
);
